firebird.directive('smartDropdownMenuPosition', [
    '$rootScope',
    '$window',
    function ($rootScope, $window) {
        return {
            restrict: 'A',
            link: function (scope, element, attrs) {
                element.on('click', function () {
                    if (!element.hasClass('open')) {
                        var menu = element.find('.dropdown-menu');
                        var parent = element.closest('#' + attrs.smartDropdownMenuParent);

                        var spaceUp = element.offset().top - parent.offset().top;
                        var spaceDown =
                            parent.offset().top + parent.outerHeight() - element.offset().top - element.outerHeight();

                        var menuHeight = menu.outerHeight();

                        if (spaceDown < menuHeight && spaceUp >= spaceDown) {
                            element.addClass('dropup');
                        } else {
                            element.removeClass('dropup');
                        }
                    }
                });

                //Watch for changes on window resize
                angular.element($window).bind('resize', function () {
                    if (element.hasClass('open')) {
                        $rootScope.$broadcast('close-profile-dropdown');
                        element.removeClass('open');
                    }
                });
            }
        };
    }
]);
